<template>
  <div class="login">
    <div class="login_panel">
      <h1>EPS 设备管理平台</h1>
      <el-form
        ref="form"
        :model="userInfo"
        @keypress.enter.native="doLogin"
        @submit.native.prevent>
        <el-form-item>
          <el-input prefix-icon="el-icon-user" v-model="userInfo.user_name" placeholder="账号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input prefix-icon="el-icon-lock" v-model="userInfo.password" type="password" placeholder="密码" show-password></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 0;margin-top: 40px;">
          <el-button class="loginButton" @click="doLogin" type="primary">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Backend from '@/api/backend'
import { setLoginUserInfo } from '@/api/permission'

export default {
  name: 'login',
  data () {
    return {
      userInfo: {
        user_name: '',
        password: ''
      }
    }
  },
  methods: {
    doLogin () {
      if (this.userInfo.user_name === '') {
        this.$message.error('账号不能为空')
        return false
      }
      if (this.userInfo.password === '') {
        this.$message.error('密码不能为空')
        return false
      }
      Backend.post(this, '/user/login', this.userInfo)
        .then(res => {
          const Base64 = require('js-base64').Base64

          this.$store.dispatch('main/loginSuccess')
          localStorage.user_name = res.user_name
          localStorage.user_id = res.user_id
          localStorage.user_roles = res.user_roles
          localStorage.user_rights = res.rights
          localStorage.head_image = res.head_image || ''
          this.$resetSetItem('is_validated', res.is_validated)
          localStorage.mobile = Base64.encode(res.mobile)
          setLoginUserInfo()
          this.$router.push({ path: '/' })
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss">
.login {
  background: url(../../assets/imgs/login_bg.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: relative;
  .login_panel {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 514px;
    text-align:center;
    padding: 42px 0;
    background: #FFFFFF;
    box-shadow: 0px 0px 51px 0px rgba(0, 115, 99, 0.21);
    border-radius: 10px;
    h1{
      color: #1BC5D7;
      font-size: 36px;
      margin-bottom: 44px;
    }
    .el-form{
      width: 70%;
      margin: 0 auto;
    }
    .loginButton{
      width: 100%;
      height: 48px;
      background: #00C8C8;
      border: unset;
      border-radius: 4px;
      font-size: 16px;
    }
    .el-input--small .el-input__inner {
      background: #eeeeee;
      height: 56px;
      font-size: 16px;
    }
    .el-input__prefix {
      font-size: 18px;
      color: #999999;
    }
  }
}
</style>
